"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetGtmSessionAttributes = GetGtmSessionAttributes;
exports.GetGtmPageAttributes = GetGtmPageAttributes;
exports.GetGtmVpvAttributesFromActivePage = GetGtmVpvAttributesFromActivePage;
exports.GetGtmProductsFromObj = GetGtmProductsFromObj;

var _store = _interopRequireDefault(require("../../store"));

var _get = _interopRequireDefault(require("lodash/get"));

var _each = _interopRequireDefault(require("lodash/each"));

var _runtimeConfigHelper = require("../../helpers/runtime-config-helper");

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

function GetGtmSessionAttributes() {
  var state = (0, _store["default"])().getState();
  var isAuthenticated = (0, _get["default"])(state, 'auth.isAuthenticated');
  var isFreeAccount = (0, _get["default"])(state, 'auth.isFreeAccount');
  var userType = isAuthenticated !== true ? 'anonymous' : isFreeAccount ? 'free' : 'paid'; // todo add employer

  var userId = (0, _get["default"])(state, 'auth.globalIdentity') || '';
  var currency = (0, _get["default"])(state, 'auth.billingInfo.code');
  return {
    userType: userType,
    userId: userId,
    currency: currency
  };
}

function GetGtmPageAttributes() {
  var state = (0, _store["default"])().getState();
  var pageId = (0, _get["default"])(state, 'router.activePage.pattern');
  var pageType = (0, _get["default"])(state, 'router.activePage.pageType') || '';
  var pageTypeStr = (0, _isFunction["default"])(pageType) ? pageType() : pageType;
  return {
    pageApplication: 'back-of-site',
    pageType: pageTypeStr,
    pageId: pageId,
    pageClass: '',
    brand: (0, _runtimeConfigHelper.getRuntimeConfig)()._brand
  };
}

function GetGtmVpvAttributesFromActivePage() {
  var state = (0, _store["default"])().getState();
  var activePath = (0, _get["default"])(state, 'router.activePath');
  var flowType = (0, _get["default"])(state, 'router.activePage.flowType') || '';
  var flowTypeStr = (0, _isFunction["default"])(flowType) ? flowType() : flowType;
  return {
    vpvFlow: flowTypeStr,
    vpvStep: activePath
  };
}

function GetGtmProductsFromObj(products) {
  var obj = {
    product_id: [],
    product_name: [],
    product_brand: [],
    product_variant: [],
    product_category: [],
    product_price: [],
    product_quantity: []
  };
  var requiredKeysOnProduct = ['productId', 'productName', 'productTerm', 'productPrice', 'productQuantity'];
  (0, _each["default"])(products, function (p) {
    (0, _each["default"])(requiredKeysOnProduct, function (key) {
      if (!p.hasOwnProperty(key)) {
        console.error('!!! MUST FIX !!!, productId must be set for ecom tracking/n find our more: https://confluence.endurance.com/display/EWB/Analytics+Tracking');
      }
    });

    if (!p.productCategory) {
      var productId = (0, _camelCase["default"])(p.productId);

      if (productId && productId.indexOf('plan') !== -1) {
        // appmarket sites
        p.productCategory = 'site';
      } else if (productId && productId.indexOf('domain') !== -1) {
        // appmarket domain
        p.productCategory = 'domain';
      } else {
        // For now, track all misc as appmarket apps (also gsuite and email) we can extend this later
        p.productCategory = 'apps';
      }
    }

    obj.product_id.push((0, _camelCase["default"])(p.productId));
    obj.product_brand.push((0, _camelCase["default"])((0, _runtimeConfigHelper.getRuntimeConfig)()._brand));
    obj.product_name.push((0, _camelCase["default"])(p.productName));
    obj.product_variant.push((0, _camelCase["default"])(p.productId) + '_' + (0, _camelCase["default"])(p.productTerm));
    obj.product_category.push((0, _camelCase["default"])(p.productCategory));
    obj.product_price.push(p.productPrice);
    obj.product_quantity.push(p.productQuantity);
  });
  return obj;
}